
import { defineComponent } from "vue";
import { Field, ErrorMessage } from "vee-validate";

export default defineComponent({
  components: {
    Field,
    ErrorMessage,
  },
  props: {
    cardNumber: {
      type: String,
      required: true,
    },
    cardExpiration: {
      type: String,
      required: true,
    },
    cardCVC: {
      type: String,
      required: true,
    },
  },
  setup() { },
});
